<template>
  <div class="doclib-search">
    <div class="search-input">
      <input type="text" placeholder="请输入搜索内容" @keydown="searchFile" v-model="searchText">
      <i class="iconfont icon-search"></i>
      <span @click="closeDialog">取消</span>
    </div>
    <div class="loading-indicator" v-if="showLoading">
      <i class="circle-icon-loading"/>
      <span>搜索中...</span>
    </div>
    <div class="no-result" v-else-if="noResult">
      <img src="https://p2.ssl.qhimg.com/t110b9a93012cf6a75891be39b4.png" alt="">
      <p>没有搜索到“{{searchTextOld}}”相关的消息</p>
    </div>
    <div class="file-list" @scroll="handleScroll" v-else>
      <template v-for="(file, fileIndex) in fileList">
        <file-card
          :card-data="file"
          :key="fileIndex"
          :permissionsData="permissionsData"
          @show-detail="showFileDetailFn"
          @show-menu="showMenuListFn"
        ></file-card>
      </template>
    </div>

    <common-footer-dialog v-if="showDetailDialog" @close-dialog="closeDetailDialog">
      <template #default>
        <file-detail :card-data="cardData"></file-detail>
      </template>
    </common-footer-dialog>

    <common-footer-dialog v-show="showMenuList" @close-dialog="closeMenuListFn">
      <template #default>
        <menu-list
          :cardData="cardData"
          @menu-click="menuClickFn"
        ></menu-list>
      </template>
    </common-footer-dialog>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import { LIBRARY_USER_PERMISSIONS, SEARCH_LIBRARY } from '@/config/api'
import FileCard from './FileCard'
import CommonFooterDialog from '../CommonFooterDialog'
import MenuList from './MenuList'
import FileDetail from './FileDetail'
import config from '@/config'
import { menuMixin, CommonMixin } from '../file/commonMixin'
export default {
  name: 'DoclibSearch',
  data () {
    return {
      permissionsData: {},
      fileList: [],
      showMenuList: false,
      searchText: (this.$route.query && this.$route.query.text) || '',
      fileListTotalPage: 2,
      fileListPage: 1,
      cardData: {},
      showDetailDialog: false,
      noResult: false,
      searchTextOld: (this.$route.query && this.$route.query.text) || '',
      prevLink: (this.$route.query && this.$route.query.prev_link) || '/doclib/list',
      showLoading: false
    }
  },
  mixins: [menuMixin, CommonMixin],
  components: {
    FileCard,
    CommonFooterDialog,
    MenuList,
    FileDetail
  },
  created () {
    this.initPermission()
    if (this.searchText) {
      this.searchFile({keyCode: 13})
    }
  },
  mounted () {
    console.log(this.searchText)
  },
  computed: {

  },
  methods: {
    initPermission () {
      ajax({
        url: LIBRARY_USER_PERMISSIONS,
        baseUrl: config.doclib_application_url,
        noPrefix: true,
        data: {
          book_id: '',
          library_id: this.$route.params.library_id
        }
      }).then((res) => {
        if (res.success) {
          this.permissionsData = res.data
        }
      })
    },
    showFileDetailFn (cardData) {
      this.cardData = cardData
      this.showDetailDialog = true
    },
    closeDetailDialog () {
      this.showDetailDialog = false
    },
    searchFile (e) {
      let keyCode = e.keyCode
      if (keyCode === 13) {
        this.showLoading = true
        ajax({
          url: SEARCH_LIBRARY,
          baseUrl: config.doclib_application_url,
          noPrefix: true,
          data: {
            folder_id: '',
            library_id: '',
            page_index: this.fileListPage,
            page_size: 25,
            reSet: new Date().getTime(),
            search_key_word: this.searchText,
            search_condition: {
              date_constant: 'all',
              end_time: '',
              file_range: 'all',
              file_type: 'all',
              match_content: 'all',
              start_time: ''
            }
          }
        }).then((res) => {
          if (res.success) {
            this.fileList = this.fileList.concat(res.data.library_search_result_list || [])
            this.fileListTotalPage = res.data.total_page
            let queryParams = Object.assign({}, this.$route.query, {})
            this.$router.replace({
              query: Object.assign({}, queryParams, {
                text: this.searchText
              })
            })

            this.noResult = !res.data.total_count || res.data.total_count < 1
            this.searchTextOld = this.searchText
          }

          this.showLoading = false
        })
      }
    },
    showMenuListFn (cardData) {
      this.cardData = Object.assign({}, cardData, {id: cardData.item_id})
      this.showMenuList = true
    },
    closeMenuListFn () {
      this.showMenuList = false
    },
    menuClickFn (type, cardData) {
      this.closeMenuListFn()

      if (type === 'delete') {
        let fileList = this.fileList.filter(item => {
          return item.item_id !== cardData.item_id
        })

        this.fileList = fileList.concat([])
      }
    },
    handleScroll (e) {
      if (this.checkBottom(e) && this.fileListPage < this.fileListTotalPage) {
        this.fileListPage = this.fileListPage + 1
        this.searchFile({keyCode: 13})
      }
    },
    checkBottom (e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      return scrollTop + clientHeight >= scrollHeight - 5 // 留5px的缓冲区
    },
    closeDialog () {
      this.appFn({
        action: 'route',
        data: `${decodeURIComponent(this.prevLink)}`
      }, () => {
        window.location.href = decodeURIComponent(this.prevLink)
      })
    }
  }
}
</script>
<style lang="postcss" scoped>
.doclib-search {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 0 34px;
  box-sizing: border-box;

  & .search-input {
    padding: 12px 20px;
    display: flex;
    align-items: center;
    position: relative;

    & input {
      display: flex;
      flex: 1;
      height: 44px;
      margin-right: 16px;
      color: #1B2532;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      border-radius: 4px;
      background: #F5F8FA;
      border: none;
      padding-left: 40px;
    }

    & i {
      position: absolute;
      top: 50%;
      left: 32px;
      font-size: 16px;
      transform: translateY(-50%);
    }

    & span {
      color: #006BFF;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
    }
  }

  & .no-result {
    width: 100%;
    height: calc(100% - 68px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
      width: 220px;
      height: 150px;
    }

    & p {
      color: #1B2532;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin-top: 4px;
    }
  }

  & .loading-indicator {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: calc(100% - 68px);
    color: #999;
    line-height: 40px;
    text-align: center;

    & .circle-icon-loading {
      display: inline-block;
      width: 14px;
      height: 14px;
      border: 2px solid #cacaca;
      border-bottom: 2px solid transparent;
      border-radius: 100%;
      animation: spin infinite 1s linear;
      vertical-align: middle;
    }

    & span {
      margin-left: 5px;
      vertical-align: middle;
    }
  }
}
</style>
